import { MojitoLocalStorage, MojitoContainerLocalStorage } from './local-storage.model';
export class LocalStorageInitializeService {

  static getLocalStorageInitial(userName: string): MojitoLocalStorage {
    return {
      currentLang: 'es-ES',
      userName: userName,
      isAuthenticated: true,
      isTableViewEnabled: true,
      companyId: 0,
      companyName: '',
      trackingPaginationTop: 10
    };
  }

  static getContainerLocalStorageInitial(userName: string): MojitoContainerLocalStorage {
    return {
      currentUserName: userName,
      mojitoLocalStorageList: [this.getLocalStorageInitial(userName)]
    };
  }
}
